var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrevArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.70703 0.292787C5.8945 0.480314 5.99982 0.734622 5.99982 0.999786C5.99982 1.26495 5.8945 1.51926 5.70703 1.70679L2.41403 4.99979L5.70703 8.29279C5.88919 8.48139 5.98998 8.73399 5.9877 8.99619C5.98543 9.25838 5.88026 9.5092 5.69485 9.6946C5.50944 9.88001 5.25863 9.98518 4.99643 9.98746C4.73423 9.98974 4.48163 9.88894 4.29303 9.70679L0.293031 5.70679C0.10556 5.51926 0.000244141 5.26495 0.000244141 4.99979C0.000244141 4.73462 0.10556 4.48031 0.293031 4.29279L4.29303 0.292787C4.48056 0.105316 4.73487 0 5.00003 0C5.26519 0 5.5195 0.105316 5.70703 0.292787Z",
    fill: "#18181B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevArrow);
export default __webpack_public_path__ + "static/media/prev-arrow.9352d45895b3c89f97163770fb1d0ecd.svg";
export { ForwardRef as ReactComponent };